"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
var RetailerPaymentStatus;
(function (RetailerPaymentStatus) {
    // Waiting for the payment (boleto or credit card)
    RetailerPaymentStatus["Waiting"] = "WAITING";
    // Waiting for the payment (boleto)
    RetailerPaymentStatus["WaitingBoleto"] = "WAITING_BOLETO";
    // Retry payment new boleto created
    RetailerPaymentStatus["RetryBoleto"] = "RETRY_BOLETO";
    // Retry credit card
    RetailerPaymentStatus["RetryCreditCard"] = "RETRY_CREDITCARD";
    RetailerPaymentStatus["Paid"] = "PAID";
    RetailerPaymentStatus["Cancelled"] = "CANCELLED";
    RetailerPaymentStatus["Blocked"] = "BLOCKED";
})(RetailerPaymentStatus = exports.RetailerPaymentStatus || (exports.RetailerPaymentStatus = {}));
class RetailerPayment extends Parse.Object {
    constructor(attributes) {
        super('RetailerPayment', attributes);
    }
    // The current open order
    get order() { return this.get('order'); }
    set order(value) { this.set('order', value); }
    // All past orders that we tried to charge
    get expiredOrders() { return this.get('expiredOrders'); }
    set expiredOrders(value) { this.set('expiredOrders', value); }
    // The retailer that we are billing
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    // *DEPRECATED*: use invoice
    get invoiceURL() { return this.get('invoiceURL'); }
    set invoiceURL(value) { this.set('invoiceURL', value); }
    // Link to the invoice PDF
    get invoice() { return this.get('invoice'); }
    set invoice(value) { this.set('invoice', value); }
    // The invoice number related to this charge (OmniChat context)
    get invoiceNumber() { return this.get('retries'); }
    set invoiceNumber(value) { this.set('retries', value); }
    // Due Data of this charge
    get dueDate() { return this.get('dueDate'); }
    set dueDate(value) { this.set('dueDate', value); }
    // Total ammount due
    get amount() { return this.get('amount'); }
    set amount(value) { this.set('amount', value); }
    // Charge description
    get description() { return this.get('description'); }
    set description(value) { this.set('description', value); }
    // Number of times that we tried to bill this customer
    // undefined means that we never retried
    get retries() { return this.get('retries'); }
    set retries(value) { this.set('retries', value); }
    get lastRetryDate() { return this.get('lastRetryDate'); }
    set lastRetryDate(value) { this.set('lastRetryDate', value); }
    // Status of the current 
    get status() { return this.get('status'); }
    set status(value) { this.set('status', value); }
}
exports.RetailerPayment = RetailerPayment;
Parse.Object.registerSubclass('RetailerPayment', RetailerPayment);
//# sourceMappingURL=RetailerPayment.js.map